import routerConstants from '@/constants/routerConstants'
import { fetchBangGiaList } from '@/apis/bangGiaApi'
import { fetchCongNoKhachHang } from '@/apis/baoCaoApi'
import { fetchChuyenHangList } from '@/apis/chuyenHangApi'
import { fetchDanhSachDanhMucThuKhac } from '@/apis/danhMucThuKhacApi'
import { fetchDanhSachDiaChiLayHang } from '@/apis/diaChiLayHangApi'
import { fetchDanhSachDiaChiNhanHang } from '@/apis/diaChiNhanHangApi'
import { fetchDanhSachDonViTinh } from '@/apis/donViTinhApi'
import { fetchDatHangNccList } from '@/apis/datHangNccApi'
import { fetchDatHangList } from '@/apis/datHangApi'
import { fetchHoaDonList } from '@/apis/hoaDonApi'
import { fetchKhachHangList } from '@/apis/khachHangApi'
import { fetchKiemKeList } from '@/apis/kiemKeApi'
import { getDanhSachPhangNhomHang } from '@/apis/nhomHangApi'
import { fetchNhaCungCapList } from '@/apis/nhaCungCapApi'
import { fetchPhieuNhapKhoList } from '@/apis/phieuNhapKhoApi'
import { fetchPhieuNhanHangList } from '@/apis/phieuNhanHangApi'
import { fetchPhieuXuatKhoList } from '@/apis/phieuXuatKhoApi'
import { fetchProductList } from '@/apis/productApi'
import { fetchDanhSachThuongHieu } from '@/apis/thuongHieuApi'
import { fetchDanhSachThuocTinh } from '@/apis/thuocTinhApi'
import { fetchDanhSachTatCaThongTinXuatHoaDon } from '@/apis/thongTinXuatHoaDonApi'
import { fetchPhieuTraHangList } from '@/apis/traHangApi'
import { getListUser } from '@/apis/userApi'
import { fetchDanhSachViTri } from '@/apis/viTriApi'
import { fetchDanhSachYeuCauSuaChua } from '@/apis/yeuCauSuaChuaApi'
import type { EntityUiTestModuleConfig } from '@/modules/ui-test/scenarios/createEntityUiTest'
import type { UiTestScenarioId } from '@/modules/ui-test/uiTest.types'

const paged =
  (fn: (qs: string) => Promise<{ data: unknown[] }>) => async (): Promise<Array<Record<string, unknown>>> => {
    const res = await fn('page=1&pageSize=10000')
    return (res.data ?? []) as Array<Record<string, unknown>>
  }

const pagedSmall =
  (fn: (qs: string) => Promise<{ data: unknown[] }>) => async (): Promise<Array<Record<string, unknown>>> => {
    const res = await fn('page=1&pageSize=500')
    return (res.data ?? []) as Array<Record<string, unknown>>
  }

const catalog = (
  id: UiTestScenarioId,
  label: string,
  path: string,
  prefix: string,
  token: string,
  fetchAll: () => Promise<Array<Record<string, unknown>>>,
  maKey: string,
  tenKey: string,
  formMa: string,
  formTen: string,
  formGhiChu?: string,
): EntityUiTestModuleConfig => ({
  scenarioId: id,
  suiteLabel: label,
  listPath: path,
  testPrefix: prefix,
  maTokenPrefix: token,
  fetchAllRows: fetchAll,
  rowMaKey: maKey,
  rowTenKey: tenKey,
  formMaField: formMa,
  formTenField: formTen,
  formGhiChuField: formGhiChu,
  editPattern: 'list-modal',
  rowSelectMode: 'visible-only',
  deleteMode: 'confirm',
})

const lightVoucher = (
  id: UiTestScenarioId,
  label: string,
  path: string,
  prefix: string,
  token: string,
  fetchAll: () => Promise<Array<Record<string, unknown>>>,
  maKey: string,
): EntityUiTestModuleConfig => ({
  scenarioId: id,
  suiteLabel: label,
  listPath: path,
  testPrefix: prefix,
  maTokenPrefix: token,
  fetchAllRows: fetchAll,
  rowMaKey: maKey,
  rowTenKey: maKey,
  formMaField: maKey,
  formTenField: maKey,
  editPattern: 'route-modal',
  rowSelectMode: 'visible-only',
  skipCreate: true,
  skipEdit: true,
  skipDelete: true,
})

export const ENTITY_UI_TEST_MODULES: EntityUiTestModuleConfig[] = [
  catalog(
    'don-vi-tinh',
    'Đơn vị tính',
    routerConstants.donViTinh.list,
    'dvt',
    'UIT-DVT-',
    paged(fetchDanhSachDonViTinh),
    'maDonViTinh',
    'tenDonViTinh',
    'maDonViTinh',
    'tenDonViTinh',
    'ghiChu',
  ),
  catalog(
    'thuong-hieu',
    'Thương hiệu',
    routerConstants.thuongHieu.list,
    'thu',
    'UIT-THU-',
    paged(fetchDanhSachThuongHieu),
    'maThuongHieu',
    'tenThuongHieu',
    'maThuongHieu',
    'tenThuongHieu',
    'ghiChu',
  ),
  catalog(
    'vi-tri',
    'Vị trí',
    routerConstants.viTri.list,
    'vit',
    'UIT-VIT-',
    paged(fetchDanhSachViTri),
    'maViTri',
    'tenViTri',
    'maViTri',
    'tenViTri',
    'ghiChu',
  ),
  {
    ...catalog(
      'thuoc-tinh',
      'Thuộc tính',
      routerConstants.thuocTinh.list,
      'tt',
      'UIT-TT-',
      paged(fetchDanhSachThuocTinh),
      'maThuocTinh',
      'ten',
      'maThuocTinh',
      'ten',
      'moTa',
    ),
    skipCreate: true,
    skipEdit: true,
    skipDelete: true,
  },
  lightVoucher(
    'dia-chi-lay-hang',
    'Địa chỉ lấy hàng',
    routerConstants.diaChiLayHang.list,
    'dclh',
    'UIT-DCLH-',
    paged(fetchDanhSachDiaChiLayHang),
    'id',
  ),
  {
    scenarioId: 'danh-muc-thu-khac',
    suiteLabel: 'Danh mục thu khác',
    listPath: routerConstants.danhMucThuKhac.list,
    testPrefix: 'dtk',
    maTokenPrefix: 'UIT-DTK-',
    fetchAllRows: paged(fetchDanhSachDanhMucThuKhac),
    rowMaKey: 'maThuKhac',
    rowTenKey: 'tenThuKhac',
    formMaField: 'maThuKhac',
    formTenField: 'tenThuKhac',
    editPattern: 'route-modal',
    rowSelectMode: 'visible-only',
    deleteMode: 'direct',
    skipCreate: true,
    skipEdit: true,
  },
  lightVoucher(
    'bang-gia',
    'Bảng giá',
    routerConstants.bangGia.list,
    'bgi',
    'UIT-BGI-',
    pagedSmall(fetchBangGiaList),
    'ma',
  ),
  {
    ...lightVoucher(
      'nhom-hang',
      'Nhóm hàng',
      routerConstants.nhomHang.list,
      'nhg',
      'UIT-NHG-',
      async () => {
        const data = await getDanhSachPhangNhomHang()
        return data.map((r) => ({ ...r, maNhom: r.code, tenNhom: r.name })) as Array<Record<string, unknown>>
      },
      'maNhom',
    ),
    rowTenKey: 'tenNhom',
  },
  {
    ...lightVoucher(
      'khach-hang',
      'Khách hàng',
      routerConstants.khachHang.list,
      'khh',
      'UIT-KHH-',
      pagedSmall(fetchKhachHangList),
      'maKhachHang',
    ),
    rowTenKey: 'tenKhachHang',
  },
  {
    ...lightVoucher(
      'nha-cung-cap',
      'Nhà cung cấp',
      routerConstants.nhaCungCap.list,
      'ncc',
      'UIT-NCC-',
      pagedSmall(fetchNhaCungCapList),
      'maNhaCungCap',
    ),
    rowTenKey: 'tenNhaCungCap',
  },
  {
    scenarioId: 'user',
    suiteLabel: 'Người dùng',
    listPath: routerConstants.user.list,
    testPrefix: 'usr',
    maTokenPrefix: 'UIT-USR-',
    fetchAllRows: async () => {
      const res = await getListUser('page=1&pageSize=500')
      return (res.data ?? []) as Array<Record<string, unknown>>
    },
    rowMaKey: 'username',
    rowTenKey: 'fullName',
    formMaField: 'username',
    formTenField: 'fullName',
    editPattern: 'list-modal',
    skipCreate: true,
    skipEdit: true,
    skipDelete: true,
    skipSearch: true,
    rowSelectMode: 'visible-only',
  },
  {
    scenarioId: 'product',
    suiteLabel: 'Sản phẩm',
    listPath: routerConstants.product.list,
    testPrefix: 'prd',
    maTokenPrefix: 'UIT-PRD-',
    fetchAllRows: pagedSmall(fetchProductList),
    rowMaKey: 'code',
    rowTenKey: 'name',
    formMaField: 'code',
    formTenField: 'name',
    editPattern: 'list-modal',
    skipCreate: true,
    skipEdit: true,
    skipDelete: true,
    skipSearch: true,
    rowSelectMode: 'visible-only',
  },
  lightVoucher(
    'phieu-nhap-kho',
    'Phiếu nhập kho',
    routerConstants.phieuNhapKho.list,
    'pnk',
    'UIT-PNK-',
    pagedSmall(fetchPhieuNhapKhoList),
    'maPhieu',
  ),
  lightVoucher(
    'phieu-xuat-kho',
    'Phiếu xuất kho',
    routerConstants.phieuXuatKho.list,
    'pxk',
    'UIT-PXK-',
    pagedSmall(fetchPhieuXuatKhoList),
    'maPhieu',
  ),
  lightVoucher(
    'phieu-nhan-hang',
    'Phiếu nhận hàng',
    routerConstants.phieuNhanHang.list,
    'pnh',
    'UIT-PNH-',
    pagedSmall(fetchPhieuNhanHangList),
    'maPhieuNhan',
  ),
  lightVoucher(
    'kiem-ke',
    'Kiểm kê',
    routerConstants.kiemKe.list,
    'kke',
    'UIT-KKE-',
    pagedSmall(fetchKiemKeList),
    'maPhieuKiem',
  ),
  lightVoucher(
    'chuyen-hang',
    'Chuyển hàng',
    routerConstants.chuyenHang.list,
    'ckh',
    'UIT-CKH-',
    pagedSmall(fetchChuyenHangList),
    'maPhieuChuyen',
  ),
  lightVoucher(
    'tra-hang',
    'Trả hàng',
    routerConstants.traHang.list,
    'trh',
    'UIT-TRH-',
    pagedSmall(fetchPhieuTraHangList),
    'maPhieuTra',
  ),
  lightVoucher(
    'dat-hang-ncc',
    'Đặt hàng NCC',
    routerConstants.datHangNcc.list,
    'dhn',
    'UIT-DHN-',
    pagedSmall(fetchDatHangNccList),
    'maDatHang',
  ),
  {
    ...lightVoucher(
      'yeu-cau-sua-chua',
      'Yêu cầu sửa chữa',
      routerConstants.yeuCauSuaChua.list,
      'ycs',
      'UIT-YCS-',
      pagedSmall(fetchDanhSachYeuCauSuaChua),
      'maYeuCau',
    ),
    skipDelete: true,
  },
  lightVoucher(
    'dat-hang',
    'Đặt hàng',
    routerConstants.datHang.list,
    'dhg',
    'UIT-DHG-',
    pagedSmall(fetchDatHangList),
    'maDatHang',
  ),
  lightVoucher(
    'hoa-don',
    'Hóa đơn',
    routerConstants.hoaDon.list,
    'hdn',
    'UIT-HDN-',
    pagedSmall(fetchHoaDonList),
    'maHoaDon',
  ),
  lightVoucher(
    'cong-no',
    'Công nợ',
    routerConstants.congNo.list,
    'cno',
    'UIT-CNO-',
    pagedSmall(fetchCongNoKhachHang),
    'maKhachHang',
  ),
  {
    ...lightVoucher(
      'thong-tin-xuat-hoa-don',
      'Thông tin xuất HĐ',
      routerConstants.thongTinXuatHoaDon.all,
      'txhd',
      'UIT-TXHD-',
      async () => {
        const res = await fetchDanhSachTatCaThongTinXuatHoaDon({ page: 1, pageSize: 500 })
        return (res.data ?? []) as unknown as Array<Record<string, unknown>>
      },
      'maSoThue',
    ),
    rowTenKey: 'ten',
  },
  {
    scenarioId: 'dia-chi-nhan-hang',
    suiteLabel: 'Thông tin giao hàng',
    listPath: routerConstants.diaChiNhanHang.all,
    resolveListPath: async () => routerConstants.diaChiNhanHang.all,
    testPrefix: 'dcn',
    maTokenPrefix: 'UIT-DCN-',
    fetchAllRows: async () => {
      const res = await fetchKhachHangList('page=1&pageSize=1')
      const khId = (res.data?.[0] as unknown as Record<string, unknown> | undefined)?.id
      if (!khId) return []
      const list = await fetchDanhSachDiaChiNhanHang(String(khId))
      return (list.data ?? []).map((r) => ({
        ...(r as unknown as Record<string, unknown>),
        ma: String((r as unknown as Record<string, unknown>).id ?? ''),
      }))
    },
    rowMaKey: 'ma',
    rowTenKey: 'tenNguoiNhan',
    formMaField: 'tenNguoiNhan',
    formTenField: 'tenNguoiNhan',
    editPattern: 'route-modal',
    rowSelectMode: 'visible-only',
    skipCreate: true,
    skipEdit: true,
    skipDelete: true,
    skipSearch: true,
    maRequiredOnCreate: false,
  },
]

export const ENTITY_UI_TEST_MODULE_MAP = Object.fromEntries(
  ENTITY_UI_TEST_MODULES.map((m) => [m.scenarioId, m]),
) as Record<UiTestScenarioId, EntityUiTestModuleConfig | undefined>
